<template>
  <div class="truckbed-slider">
    <img :src="activeSlide" class="active-slide" />
    <div class="thumbnails">
      <div v-for="(image, index) of images" :key="index">
        <img
          class="thumbnail"
          :src="image"
          width="60"
          @click="goToSlide(index)"
          :class="{ active: isActiveSlide(index) }"
        />
      </div>
    </div>
    <div class="controls">
      <button @click="previousSlide"><i class="arrow left"></i></button>
      <button @click="nextSlide"><i class="arrow right"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "truckbed-slider",
  props: {
    images: {
      type: Array,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  created() {},
  mounted() {},
  computed: {
    activeSlide() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    goToSlide(index) {
      console.log(index);
      this.currentIndex = index;
    },
    isActiveSlide(index) {
      if (index == this.currentIndex) {
        return true;
      }
      return false;
    },
    previousSlide() {
      if (this.currentIndex - 1 >= 0) {
        this.currentIndex -= 1;
      }
    },
    nextSlide() {
      if (this.currentIndex + 1 < this.images.length) {
        this.currentIndex += 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.truckbed-slider {
  position: relative;
  img.active-slide {
    width: 100%;
  }
  .thumbnails {
    display: flex;
    position: absolute;
    bottom: 2em;
    left: 12%;
    @media screen and (max-width: 576px) {
      display: none;
    }
  }
  .controls {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    button {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      border: 2px solid #005cb9;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .arrow {
    border: solid #005cb9;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    height: 15px;
    width: 15px;
  }
  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-left: -.3rem;
  }

  .left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-left: .3rem;
  }
}
img.active {
  border: 1px solid #005cb9;
}
</style>